module.exports = __webpack_public_path__ + "img/20200725_152404.2579463d.jpg";